
import { UpdateForm } from "components/common/AddForm";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useMemo, useState } from "react";
import { Column, DataTable, Dropdown, Panel } from "components/uiCore";
import { showToast } from "redux/features/toast";
import { listToast, refreshObject, VatDebit } from "utils";
import { useDispatch } from "react-redux";
import { Helper } from "utils/helper";
import { MyCalendar } from "components/common/MyCalendar";
import { classNames } from "primereact/utils";
import { updateDebitNCC } from "../api";
export default function UpdateDebitNCC({ debits, onClose}: { debits: any, onClose: () => void }) {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [debitRows, setDebitRows] = useState<any[]>([]);
  const [infos, setInfos] = useState<any>({vat_all:0,accountingDate:Helper.toDayString()});
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleSubmit = (e: any) => {
    e.preventDefault();
    infos.Data = JSON.stringify(debitRows);
    setLoading(true);
    fetchDataSubmit(infos);
  };
  async function fetchDataSubmit(info: any) {
    const response = await updateDebitNCC(info);
    if (response) setLoading(false);
    if (response.status === 200) {
      if (response.data.status) {
        setInfos({ ...refreshObject(infos), status: true });
        dispatch(
          showToast({ ...listToast[0], detail: response.data.message })
        );
        onClose();
      } else {
        dispatch(
          showToast({ ...listToast[2], detail: response.data.message })
        );
      }
    } else
      dispatch(
        showToast({ ...listToast[1], detail: response.data.message })
      );
  };
 
  useEffect(() => {
      if(debits && debits.length > 0){
         setDebitRows(debits)
         console.log(debits);
         
      }
    }, [debits])
  return (
    <>
      <UpdateForm       
        className="w-full"
        style={{ margin: "0 auto" }}
        checkId={infos.id}
        loading={loading}
        onSubmit={handleSubmit}
        route={Number(id) ? "/receipt/update" : "/receipt/create"}
        AddName="Tạo công nợ"
      >
        <div className="field">
          <Panel header="Thông tin">
            <div className="grid">
              <div className="col-12">
                <div className="formgrid grid">
                  {/* <div className="field col-3">
                      <div>Ngày hạch toán</div>
                      <MyCalendar dateFormat="dd/mm/yy"
                      value={Helper.formatDMYLocal(infos.accountingDate ? infos.accountingDate : '')} // truyền nguyên ISO string
                      onChange={(e: any) =>
                        setInfos({ ...infos, accountingDate: e })}
                      className={classNames("w-full", "p-inputtext", "input-form-sm")} />
                  </div> */}
                  <div className="field col-2">
                    <div>VAT</div>
                    <Dropdown
                      value={infos.vat_all}
                      options={VatDebit}
                      optionValue="vat"
                      optionLabel="name"
                      className="p-dropdown-sm"
                      onChange={(e: any) => {
                        setInfos({ ...infos, vat_all: e.value })
                        const vatValue = Number(e.value) || 0;

                          const updated = debitRows.map(row => {
                           const total = (row.purchase_price ?? 0) + (row.purchase_com ?? 0);
                            const totalWithVat = Math.round(total + total * vatValue / 100);

                            return {
                              ...row,
                              purchase_vat: vatValue,
                              thanh_tien: totalWithVat
                            };
                          });

                          setDebitRows(updated);
                      }}
                    />
                  </div>
                   <div className="field col-12">
                     <div><b>Thông tin chi tiết</b></div>
                        <DataTable 
                          rowHover 
                          value={debitRows}
                          scrollable
                          scrollHeight="flex"
                          style={{ flex: 1 }}
                        >
                        <Column header="STT" body={(rowData:any, options:any) => options.rowIndex + 1}/>
                        <Column field="name" header="Tuyến vận chuyển" filter showFilterMenu={false} filterMatchMode="contains" />
                        <Column header="Ngày điều xe" 
                          body={(row: any,options: any) => {
                            return (
                               <>
                                <MyCalendar dateFormat="dd/mm/yy"
                                  value={Helper.formatDMYLocal(row.service_date ? row.service_date : '')}
                                  onChange={(e: any) => {
                                    const updated = [...debitRows];
                                    updated[options.rowIndex] = { ...row, service_date: e };
                                    setDebitRows(updated);
                                  }}
                                  className={classNames("w-full", "p-inputtext", "input-form-sm")} />
                               </>
                            )
                        } }/>
                        <Column field="dispatch_code" header="Mã điều xe" filter showFilterMenu={false} filterMatchMode="contains" />
                        <Column field="vehicle_number" header="Biển số" />
                        <Column field="purchase_com" header="Mua Com"
                          body={(row: any) => Helper.formatCurrency(row.purchase_com?.toString() || "0")}
                          footer={Helper.formatCurrency(
                            debitRows
                              .reduce((sum, item) => sum + (item.purchase_com || 0), 0)
                              .toString()
                          )}
                          footerStyle={{ fontWeight: "bold" }}
                        />
                        <Column field="purchase_price" header="Số tiền"
                          body={(row: any) => Helper.formatCurrency(row.purchase_price?.toString() || "0")}
                          footer={Helper.formatCurrency(
                            debitRows
                              .reduce((sum, item) => sum + (item.purchase_price || 0), 0)
                              .toString()
                          )}
                          footerStyle={{ fontWeight: "bold" }}
                        />
                          <Column
                            header="VAT"
                            body={(_: any, opt: any) => (
                              <>
                                 <div className="py-1">
                                       <Dropdown
                                        value={debitRows[opt.rowIndex].purchase_vat || 0}
                                        options={VatDebit}
                                        optionValue="vat"
                                        optionLabel="name"
                                        className="p-inputtext-sm p-dropdown-sm"
                                        onChange={(e: any) => {
                                          const vatValue = Number(e.value) || 0;
                                          const updated = [...debitRows];
                                          const row = { ...updated[opt.rowIndex] };
                                          // ✅ Chuyển price về số nguyên, loại bỏ ký tự không phải số
                                          const rawPrice =
                                            typeof row.purchase_price === "string"
                                              ? parseInt(row.purchase_price.replace(/\D/g, ""), 10) || 0
                                              : Number(row.purchase_price) || 0;
                                          const purchaseCom =
                                            typeof row.purchase_com === "string"
                                              ? parseInt(row.purchase_com.replace(/\D/g, ""), 10) || 0
                                              : Number(row.purchase_com) || 0;
                                          const total_price = rawPrice+purchaseCom;
                                          const thanh_tien = Math.round(total_price * (1 + vatValue / 100));
                                          updated[opt.rowIndex] = {
                                            ...row,
                                            purchase_vat: vatValue,
                                            thanh_tien: thanh_tien
                                          };
                                          setDebitRows(updated);
                                        }}
                                      />
                                 </div>
                              </>
                            )}
                          />
                        <Column
                          field="thanh_tien"
                          header="Thành tiền"
                          body={(_: any, opt: any) => {
                            const row = debitRows[opt.rowIndex];
                            // Chuyển price về số thực, giữ decimal
                            const purchase_price = typeof row.purchase_price === "string"
                              ? parseFloat(row.purchase_price.replace(/[^0-9.]/g, "")) || 0
                              : Number(row.purchase_price) || 0;
                            const purchase_vat = Number(row.purchase_vat) || 0;
                            const purchase_com = typeof row.purchase_com === "string"
                              ? parseFloat(row.purchase_com.replace(/[^0-9.]/g, "")) || 0
                              : Number(row.purchase_com) || 0;
                            const total_price = purchase_price + purchase_com
                            // Tính thành tiền
                            const thanh_tien = Math.round(total_price * (1 + purchase_vat / 100));
                            // ✅ Cập nhật luôn vào state
                            if (row.thanh_tien !== thanh_tien) {
                              const updated = [...debitRows];
                              updated[opt.rowIndex] = { ...row, thanh_tien };
                              setDebitRows(updated);
                            }
                            return Helper.formatCurrency(thanh_tien.toString());
                          }}
                          footer={Helper.formatCurrency(
                            debitRows
                              .reduce((sum, item) => {
                                const purchase_price = typeof item.purchase_price === "string"
                                  ? parseFloat(item.purchase_price.replace(/[^0-9.]/g, "")) || 0
                                  : Number(item.purchase_price) || 0;
                                const purchase_com = typeof item.purchase_com === "string"
                                  ? parseFloat(item.purchase_com.replace(/[^0-9.]/g, "")) || 0
                                  : Number(item.purchase_com) || 0;
                                const total_price = purchase_price + purchase_com
                                const purchase_vat = Number(item.purchase_vat) || 0;
                                return Math.round(sum + total_price * (1 + purchase_vat / 100));
                              }, 0)
                              .toString()
                          )}
                          footerStyle={{ fontWeight: "bold" }}
                        />
                        <Column field="supplierAbb" header="Nhà cung cấp" filter showFilterMenu={false} filterMatchMode="contains" />
                        </DataTable>
                  </div>
                </div>
              </div>
            </div>
          </Panel>
        </div>
      </UpdateForm>
    </>
  );
}

